document.addEventListener("DOMContentLoaded", (event) => {

  const observerEComposer = new MutationObserver(() => {

    if (window.EComposer) {
      const body = document.body;
      const templates = ['ecom-cleopatra-watches-collection'];
      
      if( window.EComposer.PAGE ) {

        if('ecom-rays-of-sun-mini-chokers' == window.EComposer.PAGE.slug ) {
          document.body.classList.add('bg-F8F5F0');
        }

        // Cleopatra ECom page
        // if (templates.some(cls => window.EComposer.PAGE.slug )) {
        if('ecom-cleopatra-watches-collection' == window.EComposer.PAGE.slug ) {

          document.body.classList.add('bg-F8F5F0', 'white');

          let lastSTop = 0;
          window.addEventListener('scroll', function () {

            let currentScroll = document.documentElement.scrollTop || 
              document.body.scrollTop || 
              window.pageYOffset || 
              0;
            let windowHeight = window.innerHeight;
            let documentHeight = document.documentElement.scrollHeight;
            const cssVar = getComputedStyle(document.body).getPropertyValue('--header-height');
            const headerHeight = parseInt(cssVar, 10);
            let targetH = windowHeight - (headerHeight/2.2);

            if( currentScroll > targetH ) {
              document.body.classList.remove('white');
            } else {
              document.body.classList.add('white');
            }

            lastSTop = currentScroll <= 0 ? 0 : currentScroll;
          });
          window.dispatchEvent(new Event('scroll'));
        }
      }
      if( window.EComposer.SECTION ) {
        if('ecom-home-collection-new' == window.EComposer.SECTION.slug ) {
          document.body.classList.add('bg-F8F5F0');
        }
      }
      observerEComposer.disconnect();
    }
  });
  observerEComposer.observe(document.documentElement, { childList: true, subtree: true });


  if (navigator.userAgent.includes("Edg") && navigator.platform.startsWith("Win")) {
    document.body.classList.add('edge-windows');
  }
  if (navigator.userAgent.includes("Chrome") && navigator.platform.startsWith("Win")) {
    document.body.classList.add('chrome-windows');
  }
  if (/Android/i.test(navigator.userAgent)) {
    document.body.classList.add('android-device');
  }
  const isSafariMac = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && navigator.platform.startsWith("Mac");
  if (isSafariMac) {
    document.body.classList.add('safari-mac');
  }
  if (/iPhone/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent) && !/CriOS|FxiOS/.test(navigator.userAgent)) {
    document.body.classList.add('safari-iphone');
  }
  if (/iPad/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent) && !/CriOS|FxiOS/.test(navigator.userAgent)) {
    document.body.classList.add('safari-ipad');
  }
  if (navigator.userAgent.includes("Chrome") && navigator.platform.startsWith("Mac")) {
    document.body.classList.add('chrome-mac');
  }

  let isMobile = false;
  window.addEventListener('resize', () => {
    isMobile = (window.matchMedia("(max-width:1199px)").matches) ? true : false;
  });
  window.dispatchEvent(new Event('resize'));

  const url = window.location.href;  
  const collectionName = url.split('/').pop().split('-').join(' ');
  if( collectionName == 'incanto') {
    document.body.classList.add(collectionName.toLowerCase());    
  }

  let lastScrollTop = 0;

  // If not store locator page
  if( ! document.body.classList.contains('store_locator_page') )  {

    if( ! isMobile ) {
    
      // Disable events while scrolling
      gsap.config({ nullTargetWarn: false });
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.addEventListener("scrollStart", () => {
        document.body.classList.add('no-scroll');
      });

      ScrollTrigger.addEventListener("scrollEnd", () => {
        document.body.classList.remove('no-scroll');
      });    
    
      // Mega Menu
      let observerNav = new MutationObserver((mutationsList, observer) => {						
      
        const tmenu_nav = document.querySelector('.tmenu_nav');
        
        if( tmenu_nav ) {
          
          if( ! isMobile ) {
            
            tmenu_nav.classList.remove('tmenu_transition_fade');
            document.querySelector('.tmenu_navbar').classList.remove('tmenu_transition_fade');
    
            // const menuItems = tmenu_nav.querySelectorAll('.tmenu_item--root');
            // if( menuItems ) {
            //   menuItems.forEach((item, i) => {
    
            //     const mainContent = document.querySelector('#MainContent');
            //     let bgImg = '';
            //     if( _SM ) {
            //       if( _SM.entries.data.megamenu[i].setting.submenu_background ) {
            //         bgImg = _SM.entries.data.megamenu[i].setting.submenu_background.background_image;
            //         setTimeout(()=>{ loadImage(bgImg); }, 500);
            //       }
            //     }
                
            //     const a = item.querySelector('.tmenu_item_link');
            //     a.addEventListener('mouseenter', (e) => {
    
            //       const parentWithClass = a.closest('.palmiero-mm');
            //       if( !parentWithClass ) {
            //         a.style.color = '#fff';
            //       }
                
            //       // if( ! document.body.classList.contains('menu-active') ) {
                    
            //         document.body.classList.add('menu-active');
    
            //         if( bgImg && mainContent ) {
            //           document.body.classList.add('plus-image');
            //           mainContent.style.setProperty('--before-background-image', 'url("'+bgImg+'")');                  
            //         }
    
            //       // }
            //     });
            //     a.addEventListener('mouseleave', (e) => {
    
            //       const parentWithClass = a.closest('.palmiero-mm');
            //       if( !parentWithClass ) {
            //         a.style.color = '#000';
            //       }
                  
            //       document.body.classList.remove('plus-image');
    
            //       if( !bgImg && mainContent ) {
            //         mainContent.style.setProperty('--before-background-image', ''); 
            //       }
    
            //     });
            //   });
            // }
        
            // tmenu_nav.addEventListener('mouseleave', (e) => {    
            //   if( document.body.classList.contains('menu-active') ) {
            //     document.body.classList.remove('menu-active', 'plus-image');
            //   }
            // });
    
            // Set header white
            const mm = tmenu_nav.querySelectorAll('.palmiero-mm');
            mm.forEach(m => {
    
              m.addEventListener('mouseenter', function () {
    
                document.body.classList.add('header-fff');
                // if (observerNav) {
                //   observerNav.disconnect();
                //   observerNav = null;
                // } 
              });
    
              m.addEventListener('mouseleave', function () {
                document.body.classList.remove('header-fff'); 
              });
            });
    
            const submenu_type_megas = tmenu_nav.querySelectorAll('.tmenu_submenu_type_mega');
            if( submenu_type_megas ) {
              submenu_type_megas.forEach(submenu_type_mega => {
    
                submenu_type_mega.addEventListener('mouseenter', function () {
      
                  const parentlink = submenu_type_mega.parentNode;
      
                  if( parentlink ) {
                    parentlink.classList.add('hovered'); 
                  }
                });
      
                submenu_type_mega.addEventListener('mouseleave', function () {
                  
                  const parentlink = submenu_type_mega.parentNode;
                  if( parentlink ) {
                    parentlink.classList.remove('hovered'); 
                  }
                });
              });
            }
          }
    
          tmenu_nav.querySelectorAll('a').forEach(link => {
            link.addEventListener('mouseover', function () {
              this.setAttribute('data-title', this.getAttribute('title'));
              this.removeAttribute('title');
            });
            link.addEventListener('mouseout', function () {
              this.setAttribute('title', this.getAttribute('data-title'));
              this.removeAttribute('data-title');
            });
          });
    
          // const megaMenuLinks = document.querySelectorAll('.tmenu_collection');
          // megaMenuLinks.forEach((link) => {
            
          //   const a = link.parentNode;
          //   a.addEventListener('click', (event) => {
          //     const parentMM = a.closest('.palmiero-mm');
          //     if( parentMM ) {
          //       const i = getElementIndex(parentMM);
          //       if( i > 0 ) {
          //         setCookie('activeLinkId', i, 1); // expires in 1 day
          //       }
          //     }
          //   });
          // });
    
          // const activeLinkId = getCookie('activeLinkId');
          // if( activeLinkId && activeLinkId > 0 ) {
          //   if( window.location.href.indexOf('collections') !== -1 ) {
          //     const mmI = activeLinkId - 1;
          //     if( mmI > 0 ) {
          //     console.log(mmI);
          //       tmenu_nav.querySelectorAll('.palmiero-mm')[mmI].querySelector('.tmenu_item_link').classList.add('tmenu_item--current');
          //     }
          //   }
          // }
        }
      });
      observerNav.observe(document.body, { childList: true, subtree: true });
    
      // Mobile Menu
      // let observerMobileNav = new MutationObserver((mutationsList, observer) => {
      //   const mobileMenuTrigger = document.querySelector('.palmiero-mobile-menu-trigger');
      //   const mobileMenuClose = document.querySelector('.palmiero-mobile-menu-close');
      //   if( mobileMenuClose ) {
      //     mobileMenuClose.addEventListener('click', function () {
      //       ScrollTrigger.normalizeScroll(true);
      //     });
      //   }
      //   if( mobileMenuTrigger ) {
      //     mobileMenuTrigger.addEventListener('click', function () {
      //       ScrollTrigger.normalizeScroll(false);
      //     });
      //     if (observerMobileNav) {
      //       observerMobileNav.disconnect();
      //       observerMobileNav = null;
      //     }
      //   }
    
      //   const visibilityInterval = setInterval(() => {
      //     const isHidden = isElementHidden('modals-leftDrawer');
      //     if( isHidden ) {
      //       ScrollTrigger.normalizeScroll(true);
      //     }
      //     // clearInterval(visibilityInterval);
      //   }, 5000);
      // });
      // observerMobileNav.observe(document.body, { childList: true, subtree: true });
    
    } else {
      // Is mobile - unload gsap
      // unloadGSAPAndScrollTrigger()
    }
  } // If not store locator page END

  // Home
  if( document.body.classList.contains('index') ) {

    const targetBtns = document.querySelectorAll('.ecom__element--button');
    if( targetBtns ) {
      targetBtns.forEach(btn => {
        const targetC = btn.closest('.core__blocks--body');
        if( targetC ) {
          const targetElement = targetC.firstElementChild.querySelector('.ecom-banner__hzoom img');
          if( targetElement ) {
            btn.addEventListener('mouseenter', function () {
               targetElement.style.transform = 'scale(1.1)';
            });
            
            btn.addEventListener('mouseleave', function () {
               targetElement.style.transform = 'scale(1)';
            });
          }
        }
      }); 
    }

    const hzoomObserver = new MutationObserver(() => {
      const el = document.querySelector('.ecom-banner__hzoom');
      if (el) {

        const targetImgs = document.querySelectorAll('.ecom-banner__hzoom.ecom-masonry__nt_promotion');
        if( targetImgs ) {
          targetImgs.forEach(img => {
            const targetElement = img.querySelector('img');
            if( targetElement ) {
              img.addEventListener('mouseenter', function () {
                 targetElement.style.transform = 'scale(1.1)';
              });
              
              img.addEventListener('mouseleave', function () {
                 targetElement.style.transform = 'scale(1)';
              });
            }
          }); 
        }
        hzoomObserver.disconnect();
      }
    });    
    hzoomObserver.observe(document.body, { childList: true, subtree: true });
   
  }

  function isElementHidden(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return true; // Element doesn't exist
  
    const computedStyle = window.getComputedStyle(element);
    return computedStyle.display === 'none';
  }

  // Langify
  var intervalLangify = setInterval(function() {
    
    const ly_custom = document.querySelector('.ly-custom-1000');
    const lang_switcher_desktop = document.querySelector('.lang-switcher.desktop');
    const lang_switcher_mobile = document.querySelector('.lang-switcher.mobile');
    
    if( ly_custom && lang_switcher_mobile && lang_switcher_desktop ) {

      window.addEventListener('resize', function() {          
       
        if( window.innerWidth >= 1200 && !hasChildWithClass(lang_switcher_desktop, 'ly-custom-1000')  ) {
          lang_switcher_desktop.appendChild( ly_custom ); 
        }

        if( window.innerWidth < 1200 && !hasChildWithClass(lang_switcher_mobile, 'ly-custom-1000')  ) {
          lang_switcher_mobile.appendChild( ly_custom ); 
        }
        
      });
      window.dispatchEvent(new Event('resize'));

      const root_ly_switcher = document.querySelector('body>.ly-switcher-wrapper.ly-breakpoint-2');
      if( root_ly_switcher && root_ly_switcher.parentElement === document.body && root_ly_switcher.childNodes.length > 0 ) {
        lang_switcher_mobile.appendChild( root_ly_switcher );
      }

      clearInterval(intervalLangify);          
    }    
  }, 100);

  function hasChildWithClass(parentElement, className) {
    // Returns true if any child has the specified class
    return parentElement.querySelector(`.${className}`) !== null;
  }

  function unloadGSAPAndScrollTrigger() {
    // Check if GSAP and ScrollTrigger are loaded
    if (window.gsap && window.ScrollTrigger) {
      // Clear all ScrollTrigger instances
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      
      // Remove GSAP and ScrollTrigger global references
      delete window.gsap;
      delete window.ScrollTrigger;
      
      // Remove any GSAP-related event listeners
      const elements = document.querySelectorAll('*');
      elements.forEach(el => {
        // Remove any GSAP-related data and animations
        if (el._gsap) {
          gsap.killTweensOf(el);
          delete el._gsap;
        }
      });
  
      // Remove any dynamically loaded GSAP scripts
      const scripts = document.querySelectorAll('script');
      scripts.forEach(script => {
        if (script.src && (script.src.includes('gsap') || script.src.includes('ScrollTrigger'))) {
          script.remove();
        }
      });
  
      // Optional: Reset any GSAP-related CSS
      document.querySelectorAll('*').forEach(el => {
        el.style.transform = '';
        el.style.opacity = '';
        el.style.transition = '';
      });
  
      console.log('GSAP and ScrollTrigger have been unloaded');
    } else {
      console.warn('GSAP or ScrollTrigger are not currently loaded');
    }
  }

});

// Product recommendations movement
(function() {
  const TARGET_SECTION_SELECTOR = '[id^="shopify-section-template--"][id$="__recommendations"]';
  const TARGET_CONTAINER_SELECTOR = '.product-recommendations-container';
  const TITLE_SELECTOR = '.product-recommendations-title';

  let done = false;
  let observer = null;

  function tryMove() {
    if (done) return;
    const section = document.querySelector(TARGET_SECTION_SELECTOR);
    const container = document.querySelector(TARGET_CONTAINER_SELECTOR);
    if (!section || !container) return;
    const hasImg = section.querySelector('img, picture, [data-product-id]');
    if (!hasImg) return;
    container.appendChild(section);
    const title = document.querySelector(TITLE_SELECTOR);
    if (title) title.style.display = 'flex';
    done = true;
    if (observer) observer.disconnect();
  }

  tryMove();
  observer = new MutationObserver(() => tryMove());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => { if (observer) observer.disconnect(); }, 30000);
})();
